<template>
  <footer class="vueFooter">
    <div class="w1400">
      <div class="sitemap">
        <dl class="item bnav" :class="{ on: expandedIndex === 0 }">
          <dt><a href='/TechnicalList'>{{ $t('nav.techTitle') }}</a><span class="arr" @click="toggleAccordion(0)"><i class="iconfont iconxjt"></i></span></dt>
          <dd class="sub" :class="{ open: expandedIndex === 0 }">
            <p><a href='/Technical1'>{{ $t('nav.tech.biomimetic') }}</a></p>
            <p><a href='/Technical2'>{{ $t('nav.tech.micelle') }}</a></p>
            <p><a href='/Technical3'>{{ $t('nav.tech.conjugate') }}</a></p>
            <p><a href='/Technical4'>{{ $t('nav.tech.fluorescent') }}</a></p>
          </dd>
        </dl>

        <dl class="itemMax bnav">
          <dt><a href='/ProductServices'>{{ $t('nav.serviceTitle') }}</a></dt>
          <dd class="sub two-columns">
            <div class="column">
              <p><a href='/Peptide'>{{ $t('nav.service.peptide') }}</a></p>
              <p><a href='/PNA'>{{ $t('nav.service.pna') }}</a></p>
              <p><a href='/Protein'>{{ $t('nav.service.protein') }}</a></p>
              <p><a href='/OligonucleotideSynthesis'>{{ $t('nav.service.oligo') }}</a></p>
              <p><a href='/CouplingLabeling'>{{ $t('nav.service.conjugation') }}</a></p>
              <p><a href='/AntibodyDrugconJugate'>{{ $t('nav.service.adc') }}</a></p>
            </div>
            <div class="column">
              <p><a href='/Customization'>{{ $t('nav.service.nanomaterial') }}</a></p>
              <p><a href='/CellMembraneExtraction'>{{ $t('nav.service.membrane') }}</a></p>
              <p><a href='/Exosomes'>{{ $t('nav.service.exosome') }}</a></p>
              <p><a href='/LNPprotein'>{{ $t('nav.service.lnp') }}</a></p>
              <p><a href='/ProteinCrystalStructure'>{{ $t('nav.service.crystal') }}</a></p>
              <p><a href='/IsotopeCompounds'>{{ $t('nav.service.isotope') }}</a></p>
            </div>
          </dd>
        </dl>

        <dl class="item bnav" :class="{ on: expandedIndex === 1 }">
          <dt><a href='/DownList'>{{ $t('nav.downloadsTitle') }}/{{ $t('nav.news') }}</a><span class="arr" @click="toggleAccordion(1)"><i class="iconfont iconxjt"></i></span></dt>
          <dd class="sub" :class="{ open: expandedIndex === 1 }">
            <p><a href='/DownList'>{{ $t('footer.sciInfo') || $t('nav.downloads.sciInfo') }}</a></p>
            <p><a href='/DownList?index=0'>{{ $t('nav.downloads.sciInfo') }}</a></p>
            <p><a href='/DownList?index=1'>{{ $t('nav.downloads.techDoc') }}</a></p>
            <p><a href='/NewsCenter'>{{ $t('nav.news') }}</a></p>
          </dd>
        </dl>

        <dl class="item bnav" :class="{ on: expandedIndex === 2 }">
          <dt><a href='/AboutWe'>{{ $t('nav.aboutTitle') }}</a><span class="arr" @click="toggleAccordion(2)"><i class="iconfont iconxjt"></i></span></dt>
          <dd class="sub" :class="{ open: expandedIndex === 2 }">
            <p><a href='/AboutWe#about'>{{ $t('nav.about.intro') }}</a></p>
            <p><a href='/AboutWe#team'>{{ $t('nav.about.team') }}</a></p>
            <p><a href='/AboutWe#parent'>{{ $t('nav.about.partners') }}</a></p>
            <p><a href='/AboutWe'>{{ $t('nav.about.join') }}</a></p>
          </dd>
        </dl>

        <dl class="item contact">
          <dt>{{ $t('footer.contact') }}</dt>
          <dd>
            <p class="tel">{{ $t('footer.phone') }}：<span class="OswaldMedium">022-86386788</span></p>
            <p>{{ $t('footer.email') }}：<a href="mailto://info@biocoupling.com">info@biocoupling.com</a></p>
            <p>{{ $t('footer.address') }}：{{ $t('footer.addressText') }}</p>
            <p>{{ $t('footer.addressDetail') }}</p>
            <div class="share">
              <a href="javascript:void(0);">
                <img src="static/picture/wx.png" class="icon">
                <img src="static/picture/footerWX.png" class="ewm">
              </a>
            </div>
          </dd>
        </dl>
        <div class="clear"></div>
      </div>

      <div class="sitemap1">
        <dl class="item1 ">
          <dt class="ewmbox"><img src="static/picture/qiyeweixin.jpg">{{ $t('footer.scanWechat') }}<br>{{ $t('footer.wechatOfficial') }}</dt>
          <dt class="ewkfbox"><img src="static/picture/weixinkefu.png">{{ $t('footer.scanService') }}<br>{{ $t('footer.wechatService') }}</dt>
        </dl>
      </div>
      <div class="clear"></div>
    </div>
    <div class="Copyright">
      <dl class="w1400 clearfix">
        <dd class="fl">
          <p class="nav"><a href="#">{{ $t('footer.legal') }}</a> | <a href="#">{{ $t('footer.sitemap') }}</a> | <a href="#">{{ $t('footer.links') }}</a></p>
          <p class="nav" style="color: #848484;">Copyright © 2024 {{ $t('footer.copyright') }} <img alt="" src="static/picture/f-ico1.png">
            <a href="#"> </a>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{ $t('footer.beian') }}</a>
            {{ $t('footer.icp') }}：<a href="https://beian.miit.gov.cn" target="_blank">{{ $t('footer.icp') }}</a>
          </p>
        </dd>
        <dd class="fr">Designed by Bio-Coupling Medical Lab</dd>
      </dl>
    </div>
  </footer>

  <div class="totop" @click="scrollToTop"><i class="iconfont icontop"></i></div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'vueFooter',
  setup() {
    const expandedIndex = ref(-1);

    function toggleAccordion(index) {
      if (expandedIndex.value === index) {
        expandedIndex.value = -1;
      } else {
        expandedIndex.value = index;
      }
    }

    function scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return { expandedIndex, toggleAccordion, scrollToTop };
  }
};
</script>

<style scoped>
.two-columns {
  display: flex;
  gap: 20px;
}

.two-columns .column {
  flex: 1;
}

/* Accordion: mobile-only, hidden on desktop where sub is always visible */
@media (max-width: 768px) {
  .vueFooter .item .sub {
    display: none;
  }
  .vueFooter .item .sub.open {
    display: block;
  }
}
</style>
